import React from 'react';
import { Link } from 'react-router-dom';

// FOR ELECTRON PLEASE UPDATE FUNCTIONS
export const addButton = (destinazione) => {
  return (
    <div className='fixed-action-btn'>
      <Link className='btn-floating green btn-large' to={destinazione}>
        <i className='material-icons'>add</i>
      </Link>
    </div>
  );
};

export const folderButton = ({ cloudURL }, iconInPicture) => {
  return cloudURL ? (
    <a
      href={cloudURL}
      target='_blank'
      className={`btn-floating light-blue accent-3 ${
        iconInPicture ? 'icon-in-picture' : 'btn-floating-margin right'
      }`}
    >
      <i className='material-icons'>cloud</i>
    </a>
  ) : (
    ''
  );
};

export const contactDetailsButton = (cliente) => {
  return (
    <div>
      {cliente.email && (
        <a
          href={`mailto:${cliente.email}`}
          className='btn-floating blue right btn-floating-margin'
        >
          <i className='material-icons'>email</i>
        </a>
      )}

      {cliente.telefono1 && (
        <a
          href={`tel:${cliente.telefono1}`}
          className='btn-floating light-green accent-3 right btn-floating-margin'
        >
          <i className='material-icons'>phone</i>
        </a>
      )}
      {cliente.cellulare && (
        <a
          href={`tel:${cliente.cellulare}`}
          className='btn-floating light-green accent-3 right btn-floating-margin'
        >
          <i className='material-icons'>phone_iphone</i>
        </a>
      )}
      {cliente.cloudURL && folderButton(cliente)}
    </div>
  );
};

export const editButton = (path) => {
  return (
    <Link className='btn-floating orange right btn-floating-margin' to={path}>
      <i className='material-icons'>edit</i>
    </Link>
  );
};

export const linkButton = (url, label) => {
  return (
    <a
      href={url}
      target='_blank'
      rel='noopener noreferrer'
      className='btn blue btn-margin'
    >
      {label}
    </a>
  );
};

export const imageView = (imgArray, sectionTitle) => {
  return (
    <div className='container'>
      {imgArray && imgArray.length > 0 && (
        <div className='grey lighten-4'>
          <div>
            <h1>{sectionTitle}</h1>
          </div>{' '}
          {imgArray.map((imgSource, i) => (
            <img className='foto' key={i} src={imgSource} />
          ))}
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/elements.js